<mat-tab-group>
  <mat-tab *ngFor="let tab of tabs" [label]="tab.label">
    <ng-template #comp></ng-template>
  </mat-tab>
</mat-tab-group>
